export enum GetterTypes {
  'compareElementsAmount' = 'compareElementsAmount',
  'compareElements' = 'elecompareElementsments',
  'isSelected' = 'isSelected',
}
